import { createContext, useContext, useState } from 'react'

const NotificationContext = createContext(null)

export const NotificationProvider = ({ children }) => {
	const [message, setMessage] = useState('')
	const [count, setCount] = useState(0)
	const [visible, setVisible] = useState(false)

	const pushNotification = (msg, number = 1) => {
		setMessage(msg)
		setCount(prev => prev + number)
		setVisible(true)
	}

	const clearNotification = () => {
		setMessage('')
		setCount(0)
		setVisible(false)
	}

	return (
		<NotificationContext.Provider
			value={{
				message,
				count,
				visible,
				pushNotification,
				clearNotification,
			}}
		>
			{children}
		</NotificationContext.Provider>
	)
}

export const useNotification = () => {
	const ctx = useContext(NotificationContext)
	if (!ctx) {
		throw new Error('lỗi')
	}
	return ctx
}
